import * as React from "react";
import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const homeownerFeatures = ["Fast access to multiple financing sources", "Transparent and trustworthy connections", "Simplified process for home projects"];
const contractorFeatures = ["Offer financing solutions to your clients", "Vetted network of reputable lenders", "One seamless connection to funding sources"];
export default function WhoWeServe() {
  return <section id="who-we-serve" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-muted/30 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Experts, One Connection
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Bridging the gap between your project goals and the right financing solutions. We connect you to the resources you need to succeed.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <Card className="group relative overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 border-border/60 bg-card flex flex-col h-full">
            <div className="p-8 pb-4 flex justify-center items-center min-h-[240px] bg-muted/20 rounded-t-xl overflow-hidden relative">
              {}
              <div className="absolute w-48 h-48 bg-primary/5 rounded-full blur-3xl transition-transform duration-500 group-hover:scale-150" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/homeowner_financing_3d.png" alt="Homeowner Financing" className="w-48 h-48 object-contain relative z-10 transition-transform duration-500 ease-out group-hover:scale-110 group-hover:translate-x-2 group-hover:-translate-y-2 drop-shadow-xl" />
            </div>
            
            <CardHeader className="text-center pb-2">
              <CardTitle className="text-3xl font-bold text-foreground">For Homeowners</CardTitle>
              <CardDescription className="text-base text-muted-foreground mt-2">
                Finance your next project with ease and confidence.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="flex-grow pt-6">
              <ul className="space-y-4 max-w-sm mx-auto">
                {homeownerFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                    <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                    <span className="text-foreground/80 font-medium leading-tight">{feature}</span>
                  </li>)}
              </ul>
            </CardContent>
            
            <CardFooter className="pt-6 pb-8 px-8">
              <Link to="/ContactPage" className="w-full">
                <Button size="lg" className="w-full text-lg h-14 rounded-xl shadow-md transition-all hover:shadow-lg">
                  Request Funds
                </Button>
              </Link>
            </CardFooter>
          </Card>

          {}
          <Card className="group relative overflow-hidden transition-all duration-500 hover:shadow-2xl hover:shadow-primary/20 hover:-translate-y-2 bg-primary text-primary-foreground border-none flex flex-col h-full">
            {}
            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" />
            
            <div className="p-8 pb-4 flex justify-center items-center min-h-[240px] bg-black/10 rounded-t-xl overflow-hidden relative">
              {}
              <div className="absolute w-48 h-48 bg-ring/10 rounded-full blur-3xl transition-transform duration-500 group-hover:scale-150" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/contractor_financing_3d.png" alt="Contractor Financing" className="w-48 h-48 object-contain relative z-10 transition-transform duration-500 ease-out group-hover:scale-110 group-hover:-translate-x-2 group-hover:-translate-y-2 drop-shadow-[0_20px_20px_rgba(0,0,0,0.5)]" />
            </div>
            
            <CardHeader className="text-center pb-2 relative z-10">
              <CardTitle className="text-3xl font-bold text-primary-foreground">For Contractors</CardTitle>
              <CardDescription className="text-base text-primary-foreground/70 mt-2">
                Offer financing solutions to close more deals.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="flex-grow pt-6 relative z-10">
              <ul className="space-y-4 max-w-sm mx-auto">
                {contractorFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                    <CircleCheck className="w-6 h-6 text-ring shrink-0 mt-0.5 drop-shadow-sm" />
                    <span className="text-primary-foreground/90 font-medium leading-tight">{feature}</span>
                  </li>)}
              </ul>
            </CardContent>
            
            <CardFooter className="pt-6 pb-8 px-8 relative z-10">
              <Link to="/ContactPage" className="w-full">
                <Button size="lg" className="w-full text-lg h-14 rounded-xl bg-ring text-primary hover:bg-ring/90 shadow-[0_0_20px_rgba(var(--ring),0.3)] transition-all hover:shadow-[0_0_25px_rgba(var(--ring),0.5)] border-none">
                  Offer Financing
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}